<template>
    <div style="background: rgba(0,0,0,255) !important;width:100%;height:100%;padding:100px;"

    >
        <video id="video_flare2"  muted="" loop autoplay class="fullscreen-bg__video" style="">
            <source :src="require('../assets/white_flare.webm')" type="video/webm">

        </video>
        <v-img
                style="color:white;position:absolute;top:20px;left:20px;"
                :src="require('../assets/logo.png')"
                :height="24"
                :width="80"
                contain

        ></v-img>
        <v-img
                style="color:white;position:absolute;top:-20px;right:20px;"
                :src="require('../assets/Giving-Gamers-Colour.png')"
                :height="120"
                :width="120"
                contain>

        </v-img>



        <v-row align="center" justify="center" style="margin-top:0px;height:100%;">
            <v-col>
                <CharityLeaderboardComp  :tab=0 :event_name="gg" ></CharityLeaderboardComp>

            </v-col>


            <v-col>
                <CharityLeaderboardComp  :tab=2 :leaderboard_type="top" :event_name="gg"   ></CharityLeaderboardComp>

            </v-col>
        </v-row>

        <v-row align="center" justify="center" style="">




        </v-row>
    </div>

</template>

<script>
    import CharityLeaderboardComp from "../components/CharityLeaderboardComp";

    export default {
        name: "CharityLeaderboard",
        components:{CharityLeaderboardComp},
        data(){
            return{
                amount_donated:0,
              milestones:[5000,10000,25000,50000,75000,100000,150000,200000,250000,300000,350000,450000,500000,550000,600000,672491,800000,1000000,1250000,1500000,1500000,1750000,2000000,3000000,9000000,99000000],
            }
        },
        computed:{
            percentage_donated:function(){


                return (this.amount_donated/this.current_milestone)*100;
            },
            current_milestone:function(){

                for(let i=0;i<this.milestones.length;i++){
                    if(this.amount_donated<this.milestones[i]){
                        return this.milestones[i]
                    }
                }
                return 2000000
            }
        },
        mounted:function(){

        },
        methods:{

        }


    }
</script>

<style>
    ::-webkit-scrollbar {
        width: 0 !important;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: transparent !important;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: transparent !important;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background:transparent !important;
    }
</style>
